import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

window.initializeDatePicker = function () {
  changeTheme();
  flatpickr(".date-picker", {
    dateFormat: "Y-m-d",
    altInput: true,
    altFormat: "j \\de M, Y",
    locale: Portuguese,
    closeOnSelect: true,
    plugins: [],
  });
  flatpickr(".date-time-picker", {
    enableTime: true,
    altInput: true,
    time_24hr: true,
    locale: Portuguese,
    altFormat: "j \\de M, Y \\à\\s H:i",
    defaultHour: 19,
    defaultMinute: 30,
    closeOnSelect: false,
    plugins: [confirmDateConfig()],
  });
  flatpickr(".date-range-picker", {
    mode: "range",
    altInput: true,
    locale: Portuguese,
    dateFormat: "d/m/y",
    altFormat: "y/m/d",
    closeOnSelect: true,
    conjunction: " até ",
    plugins: [confirmDateConfig()],
  });
  flatpickr(".time-picker", {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    minTime: "08:00",
    maxTime: "18:00",
    locale: Portuguese,
    closeOnSelect: false,
    plugins: [confirmDateConfig()],
  });
  flatpickr(".month-picker", {
    locale: Portuguese,
    closeOnSelect: true,
    plugins: [
      new monthSelectPlugin({
        shorthand: true,
        dateFormat: "F",
        altFormat: "m",
        theme: savedTheme(),
      }),
    ],
  });
  function changeTheme() {
    const stylesheet = document.head.querySelector("link[href*='themes']");
    const cndBaseUrl = "https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/";
    stylesheet.href = cndBaseUrl + savedTheme() + ".css";
  }
  function confirmDateConfig() {
    return new confirmDatePlugin({
      confirmText: "OK",
      confirmIcon: "",
      showAlways: true,
    });
  }
};
